query oddsCheckerEvents(
  $first: Int,
  $offset: Int,
  $condition: EventCondition,
  $filter: EventFilter,
  $marketsCondition: MarketCondition,
  $marketsFilter: MarketFilter
) {
  allEvents(
    first: $first
    offset: $offset
    orderBy: STARTS_AT_ASC
    condition: $condition
    filter: $filter
  ) {
    events: nodes {
      eventId
      eventName
      matchState
      sportId
      competitionId
      startsAt
      isUsaView
      competitors
      limbo
      sport {
        sportId
        sportName
        sportLabel
      }
      markets: marketsByEventId(
        condition: $marketsCondition,
        filter: $marketsFilter,
      ) {
        nodes {
          source
          marketCode
          selections
          marketSummary
          marketType
          offeringStatus
          marketId
          inPlay
          displayStatus
          operatorId
        }
      }
    }
    totalCount
  }
}
